import React, { FunctionComponent, useRef, useState } from "react"
import lodash from "lodash"
import { useFormContext } from "react-hook-form"
import { Icon } from "@kuali/pure-ui"

import PillGroup from "./PillGroup"
import "./styles.scss"

interface Props {
  legendText: string
  pillGroupName: string
  pillGroupComment: string
  pillSelection: string
  onPillGroupChange?: () => {}
  onTextAreaFocus?: (focusedEl?) => {}
}

const PillFieldsetGroup: FunctionComponent<Props> = ({
  legendText,
  pillGroupName,
  pillGroupComment,
  pillSelection,
  onPillGroupChange,
  onTextAreaFocus
}) => {
  const { register, unregister, errors } = useFormContext()
  const textAreaInput = useRef(null)

  // field group name is used for the name associated with the form and validation
  const fieldGroupName = `${pillGroupName}Comment`
  // use lodash below to access any nested fields without error
  const isFieldValid = lodash.get(errors, fieldGroupName) ? false : true
  const pillSelectionType = pillSelection ? pillSelection.toLowerCase() : ""
  const [isCommentOpen, setIsCommentOpen] = useState<boolean | null>(
    pillSelectionType === "possibly" || pillSelectionType == "applicable"
      ? true
      : false
  )
  const [textAreaValue, setTextAreaValue] = useState(pillGroupComment)
  const [isAutoFocused, setAutoFocused] = useState(false)

  const handleGroupChange: any = (
    inputValue: string,
    type: "n/a" | "possibly" | "applicable"
  ) => {
    if (inputValue === "applicable" || inputValue === "possibly") {
      // refocus text area on applicable or possibly
      if (textAreaInput.current) {
        textAreaInput.current.focus()
      }

      setIsCommentOpen(true)
      setAutoFocused(true)

      // only callback change when textfield value present
      if (textAreaValue) {
        onPillGroupChange()
      }
    } else {
      // if input is not applicable or possibly strip requirement from group validation
      unregister(fieldGroupName)

      setIsCommentOpen(false)
      onPillGroupChange()
    }
  }

  const handleTextAreaChange: any = (event) => {
    onTextAreaFocus(textAreaInput)
    setTextAreaValue(event.target.value)

    // if text area has changed from empty to having a value
    // we send callback that pill group has changed
    if (!event.target.defaultValue && event.target.value) {
      onPillGroupChange()
    }
  }

  return (
    <React.Fragment>
      <PillGroup
        legendText={legendText}
        pillGroupName={pillGroupName}
        onGroupChange={handleGroupChange}
        pillText={pillSelectionType}
      />
      {isCommentOpen && (
        <div className={!isFieldValid ? "validation-error stack" : "stack"}>
          <label htmlFor={fieldGroupName}>
            Please provide an explanation:{" "}
            {!isFieldValid && <Icon name={"alert-warning"} />}
          </label>
          <textarea
            id={fieldGroupName}
            name={fieldGroupName}
            defaultValue={textAreaValue}
            autoFocus={isAutoFocused}
            onChange={(e) => handleTextAreaChange(e)}
            ref={(e) => {
              register(e, { required: true })
              textAreaInput.current = e
            }}
          ></textarea>
          {!isFieldValid && (
            <span className="validation-error">Field is required</span>
          )}
        </div>
      )}
    </React.Fragment>
  )
}
export default PillFieldsetGroup
